import { RouteType } from '../config';
import GeradorOrcamento from '../../pages/Site/geradorOrcamento/GeradorOrcamento';
import Orcamentos from '../../pages/Site/orcamentos/Orcamentos';
import Kanban from '../../pages/kanban/Kanban';
import Checkout from '../../pages/Site/checkout/Checkout';
import CalculoProdutoPreco from '../../pages/Site/calculoProdutoPreco/CalculoProdutoPreco';
import CadastroCliente from '../../pages/Site/cadastroCliente/CadastroCliente';
import CheckoutPDF from '../../pages/Site/checkoutPDF/CheckoutPDF';
import ListaClientes from '../../pages/Site/listaClientes/ListaClientes';
import CadastroLead from '../../pages/Site/cadastroPreLead/CadastroLead';
import Lead from '../../pages/Site/lead/lead';
import CheckoutReview from '../../pages/Site/checkout/Review';
import React from 'react';

const SiteRoutes: RouteType[] = [
  {
    index: true,
    element: <Orcamentos />,
    state: 'vendedor',
  },
  {
    path: '/vendedor/orcamento',
    element: <Orcamentos />,
    state: 'orcamento',
    sidebarProps: {
      displayText: 'Orçamentos',
    },
  },
  {
    path: '/vendedor/kanban',
    element: <Kanban />,
    state: 'kanban',
    sidebarProps: {
      displayText: 'Kanban',
    },
  },
  {
    path: '/vendedor/geradorOrcamento',
    element: <GeradorOrcamento />,
    state: 'geradorOrcamento',
    sidebarProps: {
      displayText: 'Gerar Orçamento',
    },
  },
  {
    path: '/vendedor/checkout',
    element: <Checkout />,
    state: 'checkout',
    sidebarProps: {
      displayText: 'Checkout',
    },
  },
  {
    path: '/vendedor/checkoutReview',
    element: <CheckoutReview />,
    state: 'checkoutReview',
    sidebarProps: {
      displayText: 'Confirmação',
    },
  },
  {
    path: '/vendedor/checkoutPDF/:id',
    element: <CheckoutPDF />,
    state: 'checkoutPDF',
    sidebarProps: {
      displayText: 'Checkout PDF',
    },
  },
  {
    path: '/vendedor/calculoProduto/:id',
    element: <CalculoProdutoPreco />,
    state: 'CalculoProduto',
    sidebarProps: {
      displayText: 'Calculo Produto',
    },
  },
  {
    path: '/vendedor/cadastroCliente',
    element: <CadastroCliente />,
    state: 'cadastroCliente',
    sidebarProps: {
      displayText: 'Cadastro Cliente',
    },
  },
  {
    path: '/vendedor/listLead',
    element: <Lead />,
    state: 'lead',
    sidebarProps: {
      displayText: 'Lead',
    },
  },
  {
    path: '/vendedor/preLead',
    element: <CadastroLead />,
    state: 'cadastroLead',
    sidebarProps: {
      displayText: 'Cadastro Pré Lead',
    },
  },
  {
    path: '/vendedor/listaClientes',
    element: <ListaClientes />,
    state: 'listaClientes',
    sidebarProps: {
      displayText: 'Lista de Clientes',
    },
  },
];

export default SiteRoutes;
